class API {
	constructor() {
		this.clientFiles = new ClientFiles()
	}
}

class ClientFiles {
	search(filters) {
		return get(`/client-files?${new URLSearchParams(filters).toString()}`)
	}

	view(params) {
		return get(`/client-file?${new URLSearchParams(params).toString()}`)
	}
}

function get(endpoint, options = {}) {
	return req(endpoint, {...options, method: "GET"})
}

function req(endpoint, options) {
	return new Promise((resolve, reject) => {
		fetch(url(endpoint), options)
			.then((res) => {
				const contentType = res.headers.get("Content-Type")
				const isJSON = contentType && contentType.includes("application/json")
				const promise = isJSON ? res.json() : res.text()
				promise.then((body) => (res.status >= 400 ? reject(apiError(body)) : resolve(body)))
			})
			.catch(() => {
				reject(apiError("Network error"))
			})
	})
}

function url(endpoint) {
	const apiUrl = process.env.API_URL
	if (!apiUrl) {
		throw new Error("API_URL environment variable is not defined")
	}
	return `${apiUrl}/analytics${endpoint}`
}

function apiError(error) {
	const unknownError = {Message: "Unknown error"}
	if (!error) return unknownError
	if (typeof error == "string") return {Message: error}
	if (error.message) return {Message: error.message}
	if (error.Message) return error
	return unknownError
}

const api = new API()
module.exports = {api}
